namespace advisorop.components.servicer{

    export class WorkflowListController {

        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        advisoryFirmId: number;
        showAddItemPopup: boolean = false;
        selWorkflowMaster: domains.IWorkflowMaster;
        workflowMasterId;

        updatingWorkflowLadda: boolean = false;
        workflows: domains.IWorkflowMaster[] = [];

        static $inject = ["servicerService", "generalService", "advisoryFirmApi", "workflowApi", "$uibModal"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private workflowApi: services.WorkflowApi,
            private $uibModal: angular.ui.bootstrap.IModalService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Workflows"
                },
                bindingOptions: {
                    dataSource: "vm.workflows",
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no workflows",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "id", visible: false, sortIndex: 0, sortOrder: "asc" },
                    { dataField: "name", caption: "Workflow Name", cellTemplate: "colWorkflowName" },
                    { dataField: "description", caption: "Description" },
                    { dataField: "taskSummaryInfo.myClaimed", caption: "My Tasks", width: 65 },
                    { dataField: "taskSummaryInfo.myTeamUnclaimed", caption: "Unclaimed", width: 65 },
                    { dataField: "taskSummaryInfo.othersInMyTeamClaimed", caption: "Others In My Team", width: 65 },
                    { dataField: "taskSummaryInfo.otherTeamClaimed", caption: "Other Team Claimed", width: 65 },
                    { dataField: "taskSummaryInfo.otherTeamUnclaimed", caption: "Other Team Unclaimed", width: 65 },
                    { dataField: "xx", caption: "Actions", cellTemplate: "btnActions", width: "200" }
                ],
            };
        }

        firmChanged(): void {console
            //console.log("SELECTED FIRM IS:", this.selFirm);
            this.advisoryFirmId = this.selFirm.id;
            this.loadWorkflows();
        }

        loadWorkflows(): void {
            //console.log("ADV FIRM ID IS", this.advisoryFirmId);
            this.workflowApi.getWorkflows(this.advisoryFirmId, true, true, this.workflowMasterId)
                .then((response) => {
                   this.workflows = response.data;
                   this.dg.dataSource = this.workflows;
                }).
                catch(err => {
                    toastr.error("Cannot fetch workflows for this advisory firm!");
                });
        };

        addWorkflowItem(workflowMaster: domains.IWorkflowMaster): void {
            this.selWorkflowMaster = workflowMaster;
            this.openNewWorkflowPopup();
        }

        openNewWorkflowPopup = function (): any {
            const $ctrl = this as WorkflowListController;
            var pc = this;
            var modalInstance = $ctrl.$uibModal.open({
                animation: true,
                component: "popNewWorkflowInstance",
                //templateUrl: "spa/advisor-module/components/pop-new-workflow-instance.html",
                //controller: "PopNewWorkflowInstanceController",
                size: "lg",
                controllerAs: "pc",
                bindToController: true,
                resolve: {
                    workflowMaster: function () {
                        return $ctrl.selWorkflowMaster;
                    }
                },
            });

            modalInstance.result.then(
                function (data: domains.IWorkflowInstance) { // close 

                }, function (data) { // dismiss
                    //console.log("Modal callback 2", data);
                }, function (data) { // result promise rejected
                    //console.log("Modal callback 3", data);
                }
            );

            return modalInstance;

        };

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }
    }

    class WorkflowList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                workflowMasterId: "<", // optional to get list of workflows for specific workflow master, otherwise will load workflows for all masters.
            };
            this.controller = WorkflowListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/workflow-list.html";
        }
    }
    angular.module(Constants.APP).component("workflowList", new WorkflowList());
}